<template>
	<PopUp
		:title="title"
		size="lg"
		hide-ok
		hide-cancel
		@hidden="$emit('hidden')"
	>
		<Resend
			:type="type"
			:resend-function="resendFunction"
			:change-function="changeFunction"
			:phone="phone"
			@success="$emit('success')"
		/>
	</PopUp>
</template>

<script>
import PopUp from "@/vue/common/PopUp";
import Resend from "./Resend";

const TYPE_EMAIL = 'email';
const TYPE_MOBILE_PHONE = 'mobilePhone';

const TITLES = {
	[TYPE_EMAIL]: 'E-Mail Adresse bestätigen',
	[TYPE_MOBILE_PHONE]: 'Mobilnummer bestätigen',
};

export default {

	components: {
		Resend,
		PopUp,
	},

	props: {
		type: {
			type: String,
			required: true,
		},
		resendFunction: {
			type: Function,
			required: true,
		},
		changeFunction: {
			type: Function,
			required: true,
		},
		phone: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		return {};
	},

	computed: {
		title ()
		{
			return TITLES[this.type];
		},
	},
}
</script>
